export const ADMIN = "admin";
export const MANAGER = "manager";
export const AGENT = "basic";
export const SUPERADMIN = "superadmin";